/**
 * Ritmo com que o navegador reconsulta o servidor enquanto espera um pagamento
 * do gateway confirmar.
 *
 * Mora em `shared` porque **não é política do funil self**: quem decide que a
 * cobrança foi paga é o webhook do Asaas, e toda tela que espera esse webhook
 * precisa do mesmo ritmo — o funil de negociação, o de notificação e o
 * financeiro do processo arbitral. Enquanto viveu em
 * `features/negociacaoSelf/constants`, duas outras features já alcançavam esse
 * subdiretório interno, o que a Non-Negotiable Rule #6 proíbe e o
 * `no-restricted-imports` não pegava (os globs cobrem
 * `components|store|hooks|services`, não `constants`).
 *
 * Boleto pode levar minutos para compensar: o backoff e o teto existem para que
 * uma espera longa não vire vinte minutos de requisição a cada 5 s.
 */

/** Primeira reconsulta depois de o usuário voltar do gateway. */
export const PAGAMENTO_POLLING_INTERVALO_MS = 5000;

/** Intervalo máximo entre reconsultas, depois do backoff. */
export const PAGAMENTO_POLLING_INTERVALO_MAX_MS = 30000;

export const PAGAMENTO_POLLING_BACKOFF_FATOR = 1.5;

/** Teto de relógio: depois disso o navegador desiste de perguntar. */
export const PAGAMENTO_POLLING_TETO_MS = 20 * 60 * 1000;

/**
 * Teto de ERRO, complementar ao de relógio. Servidor fora do ar não melhora com
 * insistência, e sem este teto o polling continuaria batendo até os 20 minutos.
 */
export const PAGAMENTO_MAX_ERROS_CONSECUTIVOS = 5;
